import {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import Deliverable from "./deliverable";
import {isPast} from "../../system/utils";
import {usePermission} from "../../system/usePermission";
import {normalizeMembershipEntity, prepareMembershipPayload} from "../workspace-membership/workspace-membership-identity";

const membershipPopulate = {populate: {member: {populate: ["profileImage"]}}};

export function useDeliverable() {
    const [loading, setLoading] = useState(false);
    const {user} = useSelector(state => state.auth);
    const {workspaceMembershipData} = useSelector(state => state.app);
    const dispatch = useDispatch();
    const permission = usePermission();
    const memberships = workspaceMembershipData?.workspace?.workspace_memberships || [];
    const normalizeDeliverable = (item) => normalizeMembershipEntity(item, "deliverable", memberships);
    const getDeliverables = async (projectId)=>{
        try {
            const deliverable = new Deliverable();
            const query = {
                filters: {
                    $and:[
                        {project:{$eq: projectId}},
                        // {members: {id:{$eq: user.id}}}
                    ],
                },
                populate: {
                    "owner": membershipPopulate,
                    "assignee": membershipPopulate,
                    "archivedBy": membershipPopulate,
                    "projects":true,
                    "attachments":true,
                }
            }
            const _data = await deliverable.getAll(query);

            return (_data.data || []).map(normalizeDeliverable)
        }catch (e){

        }
    }
    const getDeliverable = async (documentId)=>{
        try {
            const deliverable = new Deliverable();
            const query = {
                populate: {
                    owner: membershipPopulate,
                    assignee: membershipPopulate,
                    archivedBy: membershipPopulate,
                    project: true,
                    attachments: true,
                }
            }
            const _data = await deliverable.getById(documentId, query);

            return normalizeDeliverable(_data?.data)
        }catch (e){

        }
    }
    const updateDeliverable = async (deliverableId, deliverableData)=>{
        // if (!permission.can("deliverable.update", true))return;
        try {
            const deliverable = new Deliverable();
            const payload = prepareMembershipPayload("deliverable", deliverableData, memberships, {
                operation: "update",
                currentMembership: workspaceMembershipData,
            });
            const _data = await deliverable.update(deliverableId, payload, {
                populate: {
                    owner: membershipPopulate,
                    assignee: membershipPopulate,
                    archivedBy: membershipPopulate,
                    project: true,
                    attachments: true,
                }
            });
            return normalizeDeliverable(_data.data)
        }catch (e){

        }
    }
    const createDeliverable = async (deliverableData)=>{
        // if (!permission.can("deliverable.create", true))return;
        try {
            const deliverable = new Deliverable();
            const payload = prepareMembershipPayload("deliverable", deliverableData, memberships, {
                operation: "create",
                currentMembership: workspaceMembershipData,
            });
            const _data = await deliverable.create(payload, {
                populate: {
                    owner: membershipPopulate,
                    assignee: membershipPopulate,
                    archivedBy: membershipPopulate,
                    project: true,
                    attachments: true,
                }
            });
            return normalizeDeliverable(_data.data)
        }catch (e){

        }
    }

    const prepareTable = ({actions, config})=>{
        const fields=["title", "progress","startAt", "doneAt", "deliverableStatus","assignee"]//Object.keys(DeviceEntity.fields);
        const value=(item)=>{
            return(
                <div className="flex gap-1 align-items-center text-xs">
                    <span className="pi pi-eye cursor-pointer hover:surface-100 border-circle p-3" onClick={()=>{}}/>
                    {/*<span className="pi pi-file-edit cursor-pointer hover:surface-100 border-circle p-3" onClick={()=>{actions.onEditClicked({value:item})}}/>*/}
                    {/*<span className={`pi pi-power-off cursor-pointer hover:surface-100 border-circle p-3 ${item.kphwms_isonline?"text-red-500":"text-green-500"}`} onClick={()=>{actions.onPowerOffClicked({value:item})}}/>*/}
                    {/*<span className="pi pi-sync cursor-pointer hover:surface-100 border-circle p-3" onClick={()=>{console.log(item)}}/>*/}
                    {/*<span className="pi pi-trash cursor-pointer hover:surface-100 border-circle p-3" onClick={()=>{actions.onDeleteClicked({value:item})}}/>*/}
                </div>
            )
        }
        const fieldsConfig = {
            title:{alias:"deliverable-name", type:"TEXT", "class-name":"flex-1 pl-3 pr-3", translate:true,},
            progress:{type:"TEXT", "class-name":"flex-1 pl-3 pr-3 text-xs", translate:true,},
            deliverableStatus:{alias:"status", type:"TEXT", "class-name":"flex-1 pl-3 pr-3", translate:true,},
            startAt:{alias:"startAt", type:"PERSIAN_DATE",format:"YYYY/MM/DD dddd", "class-name":"flex-1 pl-3 pr-3", translate:true,},
            doneAt:{alias:"deliverAt", type:"PERSIAN_DATE",format:"YYYY/MM/DD dddd", "class-name":"flex-1 pl-3 pr-3", translate:true,},
            assignee:{ type:"AVATAR_GROUP", "class-name":"flex-1 pl-3 pr-3 p-2", translate:true,}
        }

        return {fields, fieldsConfig}
    }
    const getArchivedDeliverable = async (documentId) => {
        const deliverableModel = new Deliverable();

        const res = await deliverableModel.getById(documentId, {
            populate: {
                owner: membershipPopulate,
                assignee: membershipPopulate,
                archivedBy: membershipPopulate,
                project: true,
                attachments: true
            }
        });

        return normalizeDeliverable(res?.data);
    };



    return {getDeliverables, createDeliverable, updateDeliverable, getDeliverable, prepareTable , getArchivedDeliverable};
}
